// extracted by mini-css-extract-plugin
export default {"container":"Guides_container__d+T5C","section":"Guides_section__4kqHX","title":"Guides_title__iRIqn","content":"Guides_content__8isnx"};